/**
 * Just launching with backup battery.
 * TODO: Update as program expands
 */
export enum EquipmentType {
  // arbitrageBattery = 'arbitrageBattery',
  backupBattery = 'backupBattery',
}

export const EquipmentTypeLabels: Record<EquipmentType, string> = {
  [EquipmentType.backupBattery]: 'Backup Battery',
  // [EquipmentType.arbitrageBattery]: 'Arbitrage Battery',
};
